// CMS9 added the LinkChooser class.
/**
 * A link chooser is an icon with a choose method to render in the link bubble.
 */
export default class LinkChooser {
	/**
	 * Represents the data for a button that will choose a value.
	 * 
	 * @param {string} icon 
	 * @param {string} tooltip 
	 * @param {Function} choose 
	 */
	constructor( { icon, tooltip, choose } ) {
		this.icon = icon;
		this.tooltip = tooltip;
		this.choose = choose;
	}
}
